// ** React Imports
import { useState } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** MUI Imports
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import Badge from '@mui/material/Badge'
import Drawer from '@mui/material/Drawer'
import MuiAvatar from '@mui/material/Avatar'
import ListItem from '@mui/material/ListItem'
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import InputAdornment from '@mui/material/InputAdornment'

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'

// ** Icon Imports
import ICon from 'src/@core/components/icon'

import Image from 'next/image'
import { Icon } from '@iconify/react'
import NoData from 'src/components/NoData'

const ScrollWrapper = ({ children, hidden }) => {
  if (hidden) {
    return <Box sx={{ height: '100%', overflow: 'auto' }}>{children}</Box>
  } else {
    return <PerfectScrollbar options={{ wheelPropagation: false }}>{children}</PerfectScrollbar>
  }
}

const callData = [
  {
    id: 1,
    name: 'Harry',
    number: 6163566375
  }
]

const ViberSideBar = props => {
  // ** Props
  const {
    store,
    hidden,
    mdAbove,
    dispatch,
    userStatus,
    selectMessage,
    getInitials,
    sidebarWidth,
    setUserStatus,
    leftSidebarOpen,
    removeSelectedChat,
    userProfileLeftOpen,
    formatDateToMonthShort,
    handleLeftSidebarToggle,
    handleUserProfileLeftSidebarToggle,
    calls,
    chat,
    contacts,
    setCalls,
    headImg,
    setHaedImg,
    setChat,
    setContacts
  } = props

  // ** States
  const [query, setQuery] = useState('')
  const [filteredChat, setFilteredChat] = useState([])
  const [filteredContacts, setFilteredContacts] = useState([])
  const [active, setActive] = useState(null)

  // ** Hooks
  const router = useRouter()

  const handleChatClick = (type, id) => {
    dispatch(selectMessage(id))
    setActive({ type, id })
    if (!mdAbove) {
      handleLeftSidebarToggle()
    }
  }

  const hasActiveId = id => {
    if (store.chats !== null) {
      const arr = store.chats.filter(i => i.id === id)

      return !!arr.length
    }
  }

  const ListHandler = item => {
    setChat(true)
    setCalls(false)
    setContacts(false)
    setHaedImg(item.avatres)
  }

  const callHandler = () => {
    setChat(false)
    setContacts(false)
    setCalls(true)
  }

  const contactsHandler = () => {
    setChat(false)
    setCalls(false)
    setContacts(true)
  }

  const renderChats = () => {
    if (store && store.list && store.list.length) {
      let data = []
      if (query.length > 0 && filteredChat.length > 0) {
        data = filteredChat
      } else {
        data = store.list
      }

      return data.map((item, index) => {
        let a = index + 1
        if (a < 10) {
          a = '0' + a
        }
        let t = '2022-' + a + '-' + a
        const lastMessage = { time: t, message: '' }
        const activeCondition = active !== null && active.id === item.id && active.type === 'messages'

        return (
          <ListItem
            key={index}
            disablePadding
            sx={{ '&:not(:last-child)': { mb: 1.5 } }}
            onClick={() => ListHandler(item)}
            className='border-b-[1px] border-[#E5E7EB] border-opacity-40'
          >
            <ListItemButton
              onClick={() => handleChatClick('messages', item.id)}
              sx={{
                px: 1.5,
                py: 1.5,
                width: '100%',
                borderRadius: 1,
                alignItems: 'flex-start',
                ...(activeCondition && { backgroundColor: theme => '#E5E7EB' })
              }}
            >
              <ListItemAvatar sx={{ m: 0 }}>
                <Badge
                  overlap='circular'
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                  }}
                >
                  <MuiAvatar
                    src={item.avatres}
                    sx={{
                      width: 40,
                      height: 40,
                      outline: theme => `2px solid ${activeCondition ? theme.palette.common.white : 'transparent'}`
                    }}
                  />
                </Badge>
              </ListItemAvatar>

              <ListItemText
                sx={{
                  my: 0,
                  ml: 4,
                  mr: 1.5
                }}
                primary={
                  <>
                    <Typography
                      sx={{ ...(!activeCondition ? { color: 'text.secondary' } : {}), fontWeight: 600, fontSize: 14 }}
                    >
                      {item.name}
                    </Typography>
                    <div className='overflow-clip'>
                      <h2 className='w-5/6 h-[20px] text-[12px] overflow-ellipsis font-semibold text-[#292A2C] text-opacity-90'>
                        {item.chat}
                      </h2>
                    </div>
                  </>
                }
                secondary={
                  <Typography noWrap variant='body2' sx={{ ...(!activeCondition && { color: 'text.disabled' }) }}>
                    {lastMessage ? lastMessage.message : null}
                  </Typography>
                }
              />

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  flexDirection: 'column',
                  justifyContent: 'flex-start'
                }}
              >
                <Typography
                  sx={{
                    whiteSpace: 'nowrap',
                    color: activeCondition ? 'common.white' : 'text.disabled',
                    fontSize: '0.8rem',
                    fontWeight: 500
                  }}
                >
                  <p className='text-black text-opacity-60 text-[12px]'>{item.time}</p>
                </Typography>
              </Box>
            </ListItemButton>
          </ListItem>
        )
      })
    } else {
      return (
        <ListItem>
          <Typography sx={{ color: 'text.secondary' }}>
            <NoData />
          </Typography>
        </ListItem>
      )
    }
  }

  const handleFilter = e => {
    setQuery(e.target.value)
    if (store.list !== null && store.list.length > 0) {
      const filteredChatsArr = store.list.filter(item => {
        return item.name.indexOf(e.target.value) >= 0
      })

      setFilteredChat(filteredChatsArr)
    }
  }

  return (
    <div>
      <Drawer
        open={leftSidebarOpen}
        onClose={handleLeftSidebarToggle}
        variant={mdAbove ? 'permanent' : 'temporary'}
        ModalProps={{
          disablePortal: true,
          keepMounted: true // Better open performance on mobile.
        }}
        sx={{
          zIndex: 7,
          height: '100%',
          display: 'block',
          position: mdAbove ? 'static' : 'absolute',
          '& .MuiDrawer-paper': {
            boxShadow: 'none',
            overflow: 'hidden',
            width: sidebarWidth,
            position: mdAbove ? 'static' : 'absolute',
            borderTopLeftRadius: theme => theme.shape.borderRadius,
            borderBottomLeftRadius: theme => theme.shape.borderRadius
          },
          '& > .MuiBackdrop-root': {
            borderRadius: 1,
            position: 'absolute',
            zIndex: theme => theme.zIndex.drawer - 1
          }
        }}
      >
        <div className='bg-[#7C52A0] h-[60px] flex items-center w-full justify-between border-r-[1px] border-white border-opacity-10'>
          <div className='flex items-center '>
            <div>
              <Image src='/images/viber/logo.webp' alt='logo' width={90} height={50} className='rounded-full' />
            </div>
          </div>
          <div className='mr-4 cursor-pointer flex '>
            <div onClick={callHandler} className='mr-4 text-white text-opacity-90'>
              <Icon icon='fluent:call-24-filled' width={25} height={25} style={{ color: calls && 'white' }} />
            </div>
            <div onClick={contactsHandler} className='text-white text-opacity-90'>
              <Icon icon='mingcute:contacts-fill' width={25} height={25} style={{ color: contacts && 'white' }} />
            </div>
          </div>
        </div>

        <Box sx={{ height: `calc(100% - 4.125rem)` }}>
          <ScrollWrapper hidden={hidden}>
            <Box sx={{ p: theme => theme.spacing(2, 3, 3) }}>
              {/* <TextField
                fullWidth
                size='small'
                value={query}
                onChange={handleFilter}
                placeholder='Search or start new chat'
                sx={{ '& .MuiInputBase-root': { borderRadius: 1}}}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position='start'>
                      <ICon icon='mdi:magnify' fontSize='1.25rem'/>
                    </InputAdornment>
                  )
                }}
              /> */}

              {!mdAbove ? (
                <IconButton sx={{ p: 1, ml: 1, mt: 4 }} onClick={handleLeftSidebarToggle}>
                  <ICon icon='mdi:close' fontSize='1.375rem' />
                </IconButton>
              ) : null}

              <List sx={{ mb: 7.5, p: 0, mt: 4 }} className=''>
                {renderChats()}
              </List>
            </Box>
          </ScrollWrapper>
        </Box>
      </Drawer>
    </div>
  )
}

export default ViberSideBar
